import React from "react";
import { ButtonLink } from "../components/shared/Button";
import { PageMeta } from "../components/shared/PageMeta";
export function NotFound() {
  return <>
      <PageMeta title="Page not found | Oceanside Living" description="The page you were looking for couldn’t be found." data-id="element-784" data-mp="w6454r3lpz8b" />
      <div className="mx-auto max-w-site px-5 py-24 md:px-10 md:py-32" data-id="element-785" data-mp="155h5mu9qzdgw">
        <h1 className="text-[38px] font-semibold tracking-tight md:text-[56px]" data-id="element-786" data-mp="152l9nbhgmyv3">We couldn’t find that page.</h1>
        <p className="mt-4 max-w-xl text-[17px] text-slate" data-id="element-787" data-mp="1f35awe4zc3db">It may have moved. Try our home designs or get in touch with the team.</p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-788" data-mp="1juwu23lt36tf">
          <ButtonLink to="/home-designs" data-id="element-789" data-mp="1nvfm9yrm2ew5">Explore home designs</ButtonLink>
          <ButtonLink to="/" variant="secondary" data-id="element-790" data-mp="1nxjpsflllbvw">Back to home</ButtonLink>
        </div>
      </div>
    </>;
}